import { render } from "./ViewMarche.vue?vue&type=template&id=55f2af2c&ts=true"
import script from "./ViewMarche.vue?vue&type=script&lang=ts"
export * from "./ViewMarche.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__